import './utils/instrument';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import './tailwind.css';

import { loadLocale } from './i18n/intl/intl';
import Providers from './providers';
import { safeGetItem } from './utils/safeStorage';
import { store } from './utils/store';

const raw = safeGetItem('lang');
const lang = JSON.parse(raw ?? 'null');
if (lang?.code && lang.code !== 'en') {
  await loadLocale(lang.code);
}

const { default: App } = await import('./App');

ReactDOM.createRoot(document.getElementById('root')!).render(
  import.meta.env.VITE_NODE_ENV === 'production' ? (
    <Provider store={store}>
      <Providers>
        <App />
      </Providers>
    </Provider>
  ) : (
    <React.StrictMode>
      <Provider store={store}>
        <Providers>
          <App />
        </Providers>
      </Provider>
    </React.StrictMode>
  ),
);
